import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { PAGE_TYPE_TO_PATH_PREFIX, PAGE_TYPES } from '@src/constants/page-type'
import CollectionPageTemplate from '@src/pages/[...slug]/page-templates/collection-page-template'
import type { PageTemplateProps } from '@src/pages/[...slug]/page-templates/page-templates.types'
import { isMobileDevice } from '@src/quince-site-common/src/helpers/getDeviceTypeForPageRouter'
import SomethingWentWrongPage from '@src/quince-site-common/src/organisms/appLayout/molecules/errorBoundary/somethingWentWrong/ErrorPage'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

import Layout from '../../layout'

const PAGE_TEMPLATES = {
  [PAGE_TYPES.COLLECTION]: CollectionPageTemplate,
  [PAGE_TYPES.SUBCOLLECTION]: CollectionPageTemplate,
}

type PageTemplateType = keyof typeof PAGE_TEMPLATES

function isValidPageType(pageType: string | undefined): pageType is PageTemplateType {
  return Object.keys(PAGE_TEMPLATES).includes(pageType as PageTemplateType)
}

export const getServerSideProps = (async ctx => {
  if (!Array.isArray(ctx.params?.clpslug) || ctx.params.clpslug.length === 0) {
    return { notFound: true }
  }
  const pathName = `${PAGE_TYPE_TO_PATH_PREFIX.COLLECTION}/${ctx.params.clpslug.join('/')}`
  const serverSideBaseProps = await getServerSideBaseProps(ctx, pathName)
  if ('props' in serverSideBaseProps) {
    const props = await serverSideBaseProps.props

    return {
      props: {
        type: '_page',
        ...props,
      },
    }
  }
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function Page(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const ssrPageType = props.pageData?.context?.ssrPageType ?? ''
  if (!props.pageData || !isValidPageType(ssrPageType)) {
    return (
      <Layout {...props}>
        <SomethingWentWrongPage showHeader={false} />
      </Layout>
    )
  }

  const PageTemplate = PAGE_TEMPLATES[ssrPageType]

  return (
    <Layout {...props}>
      <PageTemplate
        pathname={props.pathName}
        pageData={props.pageData as unknown as PageTemplateProps['pageData']}
        isMobile={isMobileDevice(props.deviceType)}
        serverSideFeatureFlags={props.serverSideFeatureFlags}
        zipCode={props.zipCodeInfo?.zipCode ?? null}
      />
    </Layout>
  )
}
